'use client';

import { Alignable, IconName, Tab, TabList, Tabs } from '@bytel/trilogy-react';

import { PlanTypeId } from '@constants/plan';

type OfferWallTabsProps = {
    onChangeCategory: (category: boolean) => void;
    currentCategory: PlanTypeId;
    hasSimoProducts?: boolean;
};

export function OfferWallTabs({ onChangeCategory, currentCategory, hasSimoProducts = true }: OfferWallTabsProps) {
    function onChange(value: boolean) {
        onChangeCategory(value);
    }

    const isPremium = currentCategory === PlanTypeId.PREMIUM || currentCategory === PlanTypeId.PREMIUM_PRO_SELECTION;

    return (
        <Tabs small onClick={function noRefCheck() {}}>
            <TabList align={Alignable.ALIGNED_CENTER}>
                <Tab
                    label='Forfaits avec téléphone'
                    onClick={() => onChange(true)}
                    active={isPremium}
                    iconName={IconName.SIM_CARD_PLUS_MOBILE_BIG}
                    className='is-marginless'
                    data-cy='offer-wall-tabs-fam'
                    id='with-smartphone'
                />
                {hasSimoProducts && (
                    <Tab
                        label='Forfaits'
                        onClick={() => onChange(false)}
                        active={!isPremium}
                        iconName={IconName.SIM_CARD_BIG}
                        className='is-marginless'
                        data-cy='offer-wall-tabs-fsm'
                        id='without-smartphone'
                    />
                )}
            </TabList>
        </Tabs>
    );
}
